<template>
  <el-form ref="form" :model="dataInfo"  :rules="rules" :hide-required-asterisk="true" label-position="top">

    <!-- 需求概况 -->
    <div class="white-box">
      <div class="label">需求概况</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="项目总投资（万元）" prop="totalInvestment">
            <el-input v-model="dataInfo.totalInvestment" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="启动资金（万元）" prop="qdzj">
            <el-input v-model="dataInfo.qdzj" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8"/>

        <el-col :span="24">
          <el-form-item label="需用建筑面积" prop="xyjzmj">
            <el-table :data="[dataInfo]" border >
              <el-table-column label="总需求（㎡）" min-width="180" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.jzmj" placeholder="" placeholder="请输入" v-input.float :disabled="disabled"/>
                </template>
              </el-table-column>
              <el-table-column label="办公（㎡）" min-width="180" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.bgjzmj" placeholder="" placeholder="请输入" v-input.float :disabled="disabled"/>
                </template>
              </el-table-column>
              <el-table-column label="研发（㎡）"  align="center" min-width="180">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.yfjzmj" placeholder="" placeholder="请输入" v-input.float :disabled="disabled"/>
                </template>
              </el-table-column>
              <el-table-column label="生产（㎡）"  align="center" min-width="180">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sczjmj" placeholder="" placeholder="请输入" v-input.float :disabled="disabled"/>
                </template>
              </el-table-column>

            </el-table>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="需用电量（kW·h）" prop="ydl">
            <el-input v-model="dataInfo.ydl" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="需用水量(吨)" prop="ysl">
            <el-input v-model="dataInfo.ysl" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="项目配套资金（万元）" prop="ptXmzj">
            <el-input v-model="dataInfo.ptXmzj" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="风险投资（万元）" prop="fxtz">
            <el-input v-model="dataInfo.fxtz" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="短期贷款（万元）" prop="dqdk">
            <el-input v-model="dataInfo.dqdk" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贷款担保（万元）" prop="dkdb">
            <el-input v-model="dataInfo.dkdb" placeholder="请输入" v-input.float :disabled="disabled"/>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="其它" prop="remark">
            <el-input v-model="dataInfo.remark" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
    </div>


  </el-form>
</template>

<script>

import {toast} from '@/utils'
import {findByKey, toList, CARD_TYPE, YES_OR_NO} from '@/constant/Enums'

export default {
  components: {
  },
  props: {
    dataInfo: {
      type: Object,
      default: ()=>{
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var checkXyjzmj = (rule, value, callback) => {
      if (this.isEmpty(this.dataInfo.jzmj) || this.isEmpty(this.dataInfo.bgjzmj) || this.isEmpty(this.dataInfo.yfjzmj) || this.isEmpty(this.dataInfo.sczjmj)) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    return {
      rules: {
        totalInvestment: [{ required: true, message: '请输入项目总投资', trigger: 'blur' }],
        qdzj: [{ required: true, message: '请输入启动资金', trigger: 'blur' }],
        xyjzmj: [{ required: true, validator: checkXyjzmj, message: '请填写需用建筑面积', trigger: 'change' }],
        ydl: [{ required: true, message: '请输入需用电量', trigger: 'blur' }],
        ysl: [{ required: true, message: '请输入需用水量', trigger: 'blur' }],
        ptXmzj: [{ required: true, message: '请输入项目配套资金', trigger: 'blur' }],
        fxtz: [{ required: true, message: '请输入风险投资', trigger: 'blur' }],
        dqdk: [{ required: true, message: '请输入短期贷款', trigger: 'blur' }],
        dkdb: [{ required: true, message: '请输入贷款担保', trigger: 'blur' }],
      },
      zjlxOptions:toList(CARD_TYPE), //证件类别
      yesOrNoOptions:toList(YES_OR_NO),//是或否



    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    isEmpty(value)  {
      return value === '' || value === null || value === undefined
    },
    addStudyExp(){
      this.dataInfo.studyExpList.push({})
    },
    deleteStudyExp(index){
      this.dataInfo.studyExpList.splice(index, 1)
    },
    timeChange(times, data){
      if(times && times.length > 1) {
        data.startDate = times[0]
        data.endDate = times[1]
      } else {
        data.startDate = ''
        data.endDate = ''
      }
    },
    addWorkExp(){
      this.dataInfo.workExpList.push({})
    },
    deleteWorkExp(index){
      this.dataInfo.workExpList.splice(index, 1)
    },
    addZzqk(){
      this.dataInfo.sbrZzqkList.push({})
    },
    deleteZzqk(index){
      this.dataInfo.sbrZzqkList.splice(index, 1)
    },
    validate(callback){
      this.$refs['form'].validate((valid, object) => {
        callback && callback(valid, object)
      });
    },
  },
}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
